import { FILTER_SIDEBAR_FIELD_SURFACE_DEFAULTS, FILTER_SIDEBAR_FIELD_SURFACE_STYLE } from './filterSidebarSurface'
import { FILTER_TOOLBAR_FIELD_SURFACE_DEFAULTS, FILTER_TOOLBAR_FIELD_SURFACE_STYLE } from './filterToolbarSurface'
import { FORM_FIELD_SURFACE_DEFAULTS, FORM_FIELD_SURFACE_STYLE } from './formSurface'
import { POS_FIELD_SURFACE_DEFAULTS, POS_FIELD_SURFACE_STYLE } from './posSurface'
import {
  POS_UNDERLINE_FIELD_SURFACE_DEFAULTS,
  POS_UNDERLINE_FIELD_SURFACE_STYLE,
} from './posUnderlineSurface'
import type { FieldSurface, FieldSurfaceDefaults, FieldSurfaceStyle } from './types'

const STYLE_BY_SURFACE: Record<FieldSurface, FieldSurfaceStyle> = {
  form: FORM_FIELD_SURFACE_STYLE,
  filterToolbar: FILTER_TOOLBAR_FIELD_SURFACE_STYLE,
  filterSidebar: FILTER_SIDEBAR_FIELD_SURFACE_STYLE,
  pos: POS_FIELD_SURFACE_STYLE,
  posUnderline: POS_UNDERLINE_FIELD_SURFACE_STYLE,
}

const DEFAULTS_BY_SURFACE: Record<FieldSurface, FieldSurfaceDefaults> = {
  form: FORM_FIELD_SURFACE_DEFAULTS,
  filterToolbar: FILTER_TOOLBAR_FIELD_SURFACE_DEFAULTS,
  filterSidebar: FILTER_SIDEBAR_FIELD_SURFACE_DEFAULTS,
  pos: POS_FIELD_SURFACE_DEFAULTS,
  posUnderline: POS_UNDERLINE_FIELD_SURFACE_DEFAULTS,
}

export function getFieldSurfaceStyle(surface: FieldSurface = 'form'): FieldSurfaceStyle {
  return STYLE_BY_SURFACE[surface]
}

export function getFieldSurfaceDefaults(surface: FieldSurface = 'form'): FieldSurfaceDefaults {
  return DEFAULTS_BY_SURFACE[surface]
}

export function isAboveLabelLayout(surface: FieldSurface = 'form'): boolean {
  return getFieldSurfaceDefaults(surface).labelLayout === 'above'
}

export function isOutlineLabelLayout(surface: FieldSurface = 'form'): boolean {
  return getFieldSurfaceDefaults(surface).labelLayout === 'outline'
}

export function shouldShrinkOutlineLabel(surface: FieldSurface = 'form'): boolean {
  const defaults = getFieldSurfaceDefaults(surface)
  return isOutlineLabelLayout(surface) && defaults.labelShrink === true
}

export function isUnderlineFieldSurface(surface: FieldSurface = 'form'): boolean {
  return (getFieldSurfaceStyle(surface).inputChrome ?? 'box') === 'underline'
}

export function shouldUseLabelAsPlaceholder(surface: FieldSurface = 'form'): boolean {
  return getFieldSurfaceDefaults(surface).useLabelAsPlaceholder === true
}
